import type NativeArray from '@ember/array/-private/native-array';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import findBy from '@nullvoxpopuli/ember-composable-helpers/helpers/find-by';
import toggle from '@nullvoxpopuli/ember-composable-helpers/helpers/toggle';
import type Flow from 'garaje/models/flow';

interface PropagableSettingsChangedModalFlowsSearcherGroupSignature {
  Args: {
    group: {
      value: string;
      items: Flow[];
    };
    selectedChildren: NativeArray<Flow>;
  };
  Element: HTMLDivElement;
}

export default class PropagableSettingsChangedModalFlowsSearcherGroup extends Component<PropagableSettingsChangedModalFlowsSearcherGroupSignature> {
  @tracked showingAll = false;

  get allSelected(): boolean {
    const { selectedChildren, group } = this.args;
    const flows = group.items;
    return selectedChildren && flows.every((flow) => selectedChildren.includes(flow));
  }

  toggleFlow = (flow: Flow): void => {
    const selectedChildren = this.args.selectedChildren;

    if (selectedChildren.includes(flow)) {
      selectedChildren.removeObject(flow);
    } else {
      selectedChildren.addObject(flow);
    }
  };

  toggleAllSelected = (): void => {
    const { selectedChildren, group } = this.args;
    const flows = group.items;

    if (this.allSelected) {
      // @ts-expect-error - type issue
      selectedChildren.removeObjects(flows);
    } else {
      flows.forEach((flow) => selectedChildren.addObject(flow));
    }
  };

  <template>
    <div class="flow-row {{if this.allSelected 'all-selected'}} {{if this.showingAll 'showing-all'}}" ...attributes>
      <input
        data-test-check-all-group
        type="checkbox"
        checked={{this.allSelected}}
        {{on "click" this.toggleAllSelected}}
      />
      <span data-test-group-name class="group--name">{{@group.value}}</span>
      <span data-test-action-right class="group-action-right" {{on "click" (toggle "showingAll" this)}}>
        {{if this.showingAll "-  Hide" "+ Show"}}
        sign-in flows
      </span>

      <ul data-test-item-list class="item--list {{unless this.showingAll 'hidden'}}">
        {{#each @group.items as |flow|}}
          {{#let (findBy "id" flow.id @selectedChildren) as |isActive|}}
            <li data-test-item-li {{on "click" (fn this.toggleFlow flow)}}>
              <input checked={{if isActive true false}} type="checkbox" />
              <span class="group--item-name" data-test-group-item-name>{{flow.name}}</span>
            </li>
          {{/let}}
        {{/each}}
      </ul>
    </div>
  </template>
}
